/**
 * 13a — the landing site.
 *
 * The page itself is `design/Screen13a.tsx`, transcribed verbatim from the design source.
 * This file only supplies routing for the design's own calls to action.
 */

import { Interactive, type RouteMap } from './design/interactive';
import { Screen13A } from './design/Screen13A';

const ROUTES: RouteMap = {
  'set up your school': '/get-started',
  'start free': '/get-started',
  'sign in': '/signin',
  'watch a teacher use it': '/reference',
  'talk to us': '/get-started',
  /* No prices are published, so every route out of that section is a conversation. */
  'for leadership': '/get-started',
  'book a walkthrough': '/get-started',
  accessibility: '/reference/accessibility',
  'how ai is used': '/reference/mastery',
  curricula: '/reference/vocabulary',
  'the hour': '/reference/compatibility',
};

export function Landing() {
  return (
    <Interactive routes={ROUTES} label="SchoolVerse">
      <Screen13A />
    </Interactive>
  );
}
